import React from "react";

// mui components
import { Modal, Stack, Box } from "@mui/material";

// custom components
import Heading2 from "../../typography/heading-02";
import Body2 from "../../typography/body-02";

// custom animations
import Lottie from "lottie-react";
import addingFileAnimation from "../../../assets/animations/adding-file.json";

// custom styles
import styles from "./index.module.scss";

// `subText` is optional progress detail shown under "Processing..." — opt-in so the
// existing callers (which pass `text` but have always shown only the heading) are unchanged.
export default function ProcessingModal({ open, text, subText }) {
	return (
		<Modal
			open={open}
			aria-labelledby="processing modal"
			aria-describedby="processing modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<Box className={styles.animationContainer}>
					<Lottie animationData={addingFileAnimation} loop={true} />
				</Box>

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Heading2
						text="Processing..."
						extraClass={styles.processingText}
						fontType="semibold"
					/>
					{subText && (
						<Body2 text={subText} extraClass={styles.processingSubText} />
					)}
				</Stack>
			</Stack>
		</Modal>
	);
}
